module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.loggedIn) { 
    ; __append(" <li class=\"navbar-btn-wrapper\"><a class=\"btn btn-blue navbar-btn\" href=\"/account/shipments\">Dashboard</a></li> <li class=\"small navbar-text\"> <div>")
    ; __append(escapeFn( locals.email ))
    ; __append("</div> <div><a href=\"\" id=\"signout\">sign out</a></div> </li> ")
    ;  } else { 
    ; __append(" <li class=\"navbar-btn-wrapper\"><a href=\"/signin\" class=\"btn btn-default navbar-btn\">Log In</a></li> <li class=\"navbar-btn-wrapper\"><a href=\"/signup\" class=\"btn btn-red navbar-btn\">Sign Up</a></li> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/basic_navbar.ejs
// module id = 868
// module chunks = 1